import { Stack } from "@mui/material";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import InvestorCommunicationRecipientsList from "../../InvestorCommunicationRecipientsList";
import InvestorCommunicationContext from "../InvestorCommunicationContext";
import InvestorCommunicationRecipientsForm from "./InvestorCommunicationRecipientsForm";

const InvestorCommunicationRecipientsTab = () => {
  const { investorCommunication, recipients, readersByContactId, hasEditPermissions } = useDefinedContext(
    InvestorCommunicationContext,
    "InvestorCommunicationContext"
  );

  return (
    <Stack sx={{ flex: 1, pt: 2.5, pb: 2 }}>
      {hasEditPermissions ? (
        <InvestorCommunicationRecipientsForm />
      ) : (
        <InvestorCommunicationRecipientsList
          type={investorCommunication.type}
          recipients={recipients}
          readersByContactId={readersByContactId}
        />
      )}
    </Stack>
  );
};

export default InvestorCommunicationRecipientsTab;
